export default async function obtenerHistorialSinConcesion(idContribuyente) {
    const enspointHistorialSinConcesiones = `/api/historial/ObtenerHistorialSinIdConcesion/${idContribuyente}`;
    const endpointHistorialPolizas = `/api/historial/ObtenerHistorialPolizasIdContribuyente/${idContribuyente}`;

    try {
        const response = await fetch(endpointHistorialPolizas);
        const responseConceptos = await fetch(enspointHistorialSinConcesiones);

        if (response.status === 400) return [];

        const { data: dataHistorial } = await response.json();
        const { data: dataConceptos } = await responseConceptos.json();

        for (let i = 0; i < dataHistorial.length; i++) {
            dataHistorial[i].conceptos = dataConceptos
                .filter(item => dataHistorial[i].idPolizaPago === item.idPolizaPago)
                .map(item => item.descripcion.toUpperCase());
        }
        return dataHistorial.reverse();
    } catch (error) {
        return [];
    }
}
